import {
  useInView,
  InViewHookResponse,
  IntersectionOptions,
} from "react-intersection-observer";
import { useState, useEffect } from "react";

export const useInViewCompat = (
  options: IntersectionOptions
): InViewHookResponse => {
  const [hasIntersectionObserver, setHasIntersectionObserver] = useState(true);
  const [hasRunOnClient, setHasRunOnClient] = useState(false);
  const realInViewHook = useInView(options);

  useEffect(() => {
    setHasIntersectionObserver(typeof IntersectionObserver !== "undefined");
    setHasRunOnClient(true);
  }, [setHasIntersectionObserver]);

  return hasIntersectionObserver && hasRunOnClient
    ? realInViewHook
    : // eslint-disable-next-line @typescript-eslint/no-empty-function
      [() => {}, hasRunOnClient, undefined];
};
